import * as tslib_1 from "tslib";
import { AfterViewInit, OnInit } from '@angular/core';
import { PromiseState, StatefulPromise } from '../../util/stateful-promise';
import { GoogleService } from '../../google/google.service';
var PlacesInfoWindowComponent = /** @class */ (function () {
    function PlacesInfoWindowComponent(_google) {
        this._google = _google;
        this.photoUrl = null;
    }
    PlacesInfoWindowComponent.prototype.ngOnInit = function () {
    };
    PlacesInfoWindowComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._google.promise];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getActivityDetail()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PlacesInfoWindowComponent.prototype.getActivityDetail = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.activityDetailPromise = new StatefulPromise(this._google.placeDetails({
                    placeId: this.activity.place_id,
                    fields: ['name', 'rating', 'formatted_address', 'formatted_phone_number', 'photos', 'website', 'url']
                }));
                // sessionToken: new google.maps.places.AutocompleteSessionToken(),
                this.activityDetailPromise.promise.then(function (res) {
                    if (_this.activityDetailPromise.value.photos && _this.activityDetailPromise.value.photos.length > 0) {
                        _this.photoUrl = _this.activityDetailPromise.value.photos[0].getUrl({ 'maxWidth': 100, 'maxHeight': 100 });
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(PlacesInfoWindowComponent.prototype, "activityDetail", {
        get: function () {
            if (!this.activityDetailPromise || this.activityDetailPromise.state !== PromiseState.Fulfilled) {
                return null;
            }
            return this.activityDetailPromise.value;
        },
        enumerable: true,
        configurable: true
    });
    return PlacesInfoWindowComponent;
}());
export { PlacesInfoWindowComponent };
